<script setup lang="ts">
import AuSkeletonWrapper from '~/components/ui/AuSkeletonWrapper.vue'
import AuSkeleton from '~/components/ui/AuSkeleton.vue'
</script>

<template>
  <AuSkeletonWrapper>
    <div class="border-green-40 flex w-full items-stretch overflow-hidden rounded-lg border bg-white">
      <div class="flex flex-1 flex-col gap-2 p-4 md:flex-row md:items-center md:gap-4">
        <div class="min-w-0 flex-1">
          <div class="min-h-5">
            <AuSkeleton height="1.25rem" width="70%" />
          </div>
          <div class="mt-1">
            <AuSkeleton height="1rem" width="85%" />
          </div>
        </div>

        <div class="flex items-center gap-2">
          <AuSkeleton height="1rem" width="3.5rem" />
          <AuSkeleton
            height="1.5rem"
            width="1.5rem"
            border-radius="50%"
          />
        </div>
      </div>

      <div class="bg-gray-30 flex w-8 items-center justify-center self-stretch">
        <AuSkeleton height="1rem" width="0.5rem" />
      </div>
    </div>
  </AuSkeletonWrapper>
</template>
